import { useIonToast } from "@ionic/react";
import { cardOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import ActionButton from "../../../../components/button/ActionButton"
import CheckBoxItem from "../../../../components/checkbox/CheckBoxItem"
import InputItem from "../../../../components/input/InputItem"
import { DataProvider } from "../../../../library/DataProvider";
import { passToWebView } from "../../../../library/Funcs";
import { AidPostAction } from "../../../../redux/actions/Account";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";

interface Props {
    obligation: any,
    amount: any
}

const Aid: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();

    const dispatch = useAppDispatch()

    const { form_loading, resp } = useAppSelector(state => state.aidPost)

    const [action, setAction] = useState("");

    const [form, setForm] = useState({
        obligation: { value: "", validation: {}, error: "" },
        amount: { value: "0", validation: { required: true }, error: "" }
    });

    useEffect(() => {
        const aidForm = {...form};
        
        aidForm.obligation.value = props.obligation;
        aidForm.amount.value = props.amount;

        setForm(aidForm);
    }, [props])

    const [formProvider] = useState(() => new DataProvider(form, setForm));

    const formSubmitHandler = (e: any, action: string) => {
        e.preventDefault();
        
        let formValidation = formProvider.validation(form);

        setAction(action);

        if (formValidation) {
            dispatch(AidPostAction(action, form.obligation.value, form.amount.value.replace(/\D+/g, '')))
        }
    }

    useEffect(() => {
        const formDone = () => {
            if (resp != null && !form_loading) {
                if (resp.result) {
                    if (action == "pay") {
                        passToWebView("sendPayment", resp.url);
                    } else {
                        toast({ message: resp.message, duration: 2000, color: "primary" })
                    }
                } else {
                    toast({ message: resp.message, duration: 2000, color: "danger" })
                }
            }
        }

        formDone();
    }, [form_loading])

    return <>
        <InputItem name="amount" type="number" label="مبلغ" icon={cardOutline} maxlength={15} ltr spaced provider={formProvider} />

        <CheckBoxItem key="monthlyPayAidObligation" name="obligation" label="اینجانب متعهد می شوم ماهیانه مبلغ فوق را برای کمک به اهداف انجمن پرداخت نمایم." provider={formProvider} />

        <ActionButton color="blue" text="ذخیره تغییرات" click={(e: any) => formSubmitHandler(e, "")} loading={form_loading && action == ''} />

        <ActionButton text="پرداخت آنلاین" click={(e: any) => formSubmitHandler(e, "pay")} loading={form_loading && action == 'pay'} />
    </>
}

export default Aid